var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    width: 60,
    height: 60
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle",
    d: "M60 30c0 16.57-13.43 30-30 30S0 46.57 0 30 13.43 0 30 0s30 13.43 30 30zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M43.84 19.789a3.75 3.75 0 0 1 .121 5.301l-14.316 15a3.75 3.75 0 0 1-5.246.176l-8.184-7.5c-1.527-1.402-1.629-3.773-.23-5.301s3.773-1.629 5.301-.23l5.473 5.02L38.539 19.91a3.75 3.75 0 0 1 5.301-.121zm0 0",
    fillRule: "evenodd",
    fill: "rgb(100%,100%,100%)"
  })));
};
export default SvgCheckCircle;